import { LastLocationContext } from '#app/contexts/LastLocationContext/LastLocationContext.js';
import { useContext } from 'react';

/**
 * Returns the last location, or null when no prior location.
 */
export const useLastLocation = () => {
  const lastLocation = useContext(LastLocationContext);

  return lastLocation;
};
